import { Action } from '@ngrx/store';
import * as models from '../../domain/models';

export const LOAD_CAMBER_OPTIONS = '[Sourcing.AircraftAvailability] Load Camber Options';
export const LOAD_CAMBER_OPTIONS_SUCCESS = '[Sourcing.AircraftAvailability] Load Camber Options Success';
export const LOAD_CAMBER_OPTIONS_FAIL = '[Sourcing.AircraftAvailability] Load Camber Options Fail';
export const LOAD_SMART_JET_D_OPTIONS = '[Sourcing.AircraftAvailability] Load Charter Options';
export const LOAD_SMART_JET_D_OPTIONS_SUCCESS = '[Sourcing.AircraftAvailability] Load Charter Options Success';
export const LOAD_SMART_JET_D_OPTIONS_FAIL = '[Sourcing.AircraftAvailability] Load Charter Options Fail';

export class LoadCamberOptionsAction implements Action {
  readonly type = LOAD_CAMBER_OPTIONS;
}

export class LoadCamberOptionsSuccessAction implements Action {
  readonly type = LOAD_CAMBER_OPTIONS_SUCCESS;

  constructor(public payload: Array<models.CamberOption>) { }
}

export class LoadCamberOptionsFailAction implements Action {
  readonly type = LOAD_CAMBER_OPTIONS_FAIL;
}

export class LoadSmartJetDOptionsAction implements Action {
  readonly type = LOAD_SMART_JET_D_OPTIONS;
}

export class LoadSmartJetDOptionsSuccessAction implements Action {
  readonly type = LOAD_SMART_JET_D_OPTIONS_SUCCESS;

  constructor(public payload: Array<models.SmartJetDOption>) { }
}

export class LoadSmartJetDOptionsFailAction implements Action {
  readonly type = LOAD_SMART_JET_D_OPTIONS_FAIL;
}

export type Actions = LoadCamberOptionsAction
  | LoadCamberOptionsSuccessAction
  | LoadCamberOptionsFailAction
  | LoadSmartJetDOptionsAction
  | LoadSmartJetDOptionsSuccessAction
  | LoadSmartJetDOptionsFailAction;
